<mat-form-field appearance="fill" class="dictionary-select">
  <mat-label>{{label}}</mat-label>
  <mat-select [formControl]="formControl" [required]="required">
    @for (dictionaryKey of dictionaryKeys; track dictionaryKey) {
      <mat-option [value]="dictionaryKey.replace(dictionaryRoot, '')">
        <sc-dictionary-label [dictionaryKey]="dictionaryKey"></sc-dictionary-label>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
